import { render, staticRenderFns } from "./helpAndQuestions.vue?vue&type=template&id=f6b8acb4&scoped=true"
import script from "./helpAndQuestions.vue?vue&type=script&lang=js"
export * from "./helpAndQuestions.vue?vue&type=script&lang=js"
import style0 from "./helpAndQuestions.vue?vue&type=style&index=0&id=f6b8acb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b8acb4",
  null
  
)

export default component.exports